

































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  public isLoading: boolean = true;
  public isSideMenu: boolean = true;

  created() {
    //ログイン処理とマスタ初期化が完了したら画面を描画する
    this.$api.initialize().then(() => (this.isLoading = false));
  }
}
